import axios from 'axios';

// Create axios instance with base configuration
// Automatically detect API URL based on environment
const getApiBaseURL = () => {
  // If custom API URL is set in environment variables, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // In development, use same-origin /api so the dev server proxy forwards to local backend (avoids CORS)
  if (process.env.NODE_ENV === 'development') {
    return '/api';
  }
  // Production fallback
  return 'https://api.rentplus.dk/api';
};

const api = axios.create({
  baseURL: getApiBaseURL(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Let browser set Content-Type with boundary for FormData
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('userRole');
      localStorage.removeItem('userId');
      localStorage.removeItem('userData');
      // Redirect to auth app
      const authAppUrl = process.env.REACT_APP_AUTH_APP_URL || 'https://app.rentplus.dk';
      const currentUrl = window.location.origin;
      const returnPath = window.location.pathname;
      const redirectUrl = `${authAppUrl}/login?redirect=${encodeURIComponent(currentUrl)}&returnPath=${encodeURIComponent(returnPath)}`;
      window.location.href = redirectUrl;
    }
    return Promise.reject(error);
  }
);

export default api;

